import { createContext, useContext, useState } from 'react';

export interface GlobalTrapFocusContext {
    trapFocus: boolean;
    setTrapFocus: (trapFocus: boolean) => void;
}

const Ctx = createContext<GlobalTrapFocusContext>({
    trapFocus: true,
    setTrapFocus: () => undefined,
});

export const GlobalTrapFocusProvider = ({
    children,
}: {
    children: JSX.Element;
}) => {
    const [trapFocus, setTrapFocus] = useState(true);

    return (
        <Ctx.Provider value={{ trapFocus, setTrapFocus }}>
            {children}
        </Ctx.Provider>
    );
};

export const useGlobalTrapFocus = (): GlobalTrapFocusContext => {
    return useContext(Ctx);
};
